import PN from 'persian-number/src/persianNumber'

export const fileUtils = {
  imgTypes: ['png', 'jpg', 'jpeg', 'jfif'],
  docTypes: ['pdf', 'html'],
  textTypes: ['txt'],

  getFileNameWithExtension(path) {
    const lastSlashIndex = path.lastIndexOf('/')
    if (lastSlashIndex !== -1) {
      const fileNameWithExtension = path.substring(lastSlashIndex + 1)
      const parts = fileNameWithExtension.split('.')
      return {
        name: parts.slice(0, parts.length - 1).join('.'),
        extension: parts[parts.length - 1].toLowerCase()
      }
    } else {
      const parts = path.split('.')
      return {
        name: parts.slice(0, parts.length - 1).join('.'),
        extension: parts[parts.length - 1].toLowerCase()
      }
    }
  },

  getExtension(path) {
    const fileNameWithExtension = this.getFileNameWithExtension(path)
    return fileNameWithExtension?.extension
  },

  isImage(type) {
    return this.imgTypes.includes(type.toLowerCase())
  },

  isDocument(type) {
    return this.docTypes.includes(type.toLowerCase())
  },

  isTextFile(type) {
    return this.textTypes.includes(type.toLowerCase())
  }
}

export function createNumberUtils(filters) {
  return {
    numberInWords(amount, asset) {
      return (
        PN.convert(filters.formatDecimal(amount, asset.quantityDecimals)) +
        ' ' +
        this.englishToPersianAssets(asset.symbol)
      )
    },

    englishToPersianAssets(symbol) {
      let persian_assets_map = {
        USDT: 'تتر',
        BLC: 'بالانس',
        USD: 'دلار',
        IRT: 'تومان',
        AED: 'درهم',
        GBP: 'پوند',
        CAD: 'دلار کانادا',
        EUR: 'یورو'
      }
      return persian_assets_map[symbol] ?? symbol
    }
  }
}

export function createTimeUtils(i18n) {
  return {
    toCountdown(diffInMs) {
      let countdown = '00:00:00'
      if (diffInMs <= 0) {
        return countdown
      }

      const hours = Math.floor(diffInMs / (1000 * 60 * 60))
        .toString()
        .padStart(2, '0')
      const minutes = Math.floor((diffInMs % (1000 * 60 * 60)) / (1000 * 60))
        .toString()
        .padStart(2, '0')
      const seconds = Math.floor((diffInMs % (1000 * 60)) / 1000)
        .toString()
        .padStart(2, '0')

      countdown = `${hours}:${minutes}:${seconds}`
      return countdown
    },

    dateToDescription(createdAt) {
      const t = i18n.global.t
      const inputDate = new Date(createdAt)
      const today = new Date()
      const DateStart = new Date(inputDate.getFullYear(), inputDate.getMonth(), inputDate.getDate())
      const todayStart = new Date(today.getFullYear(), today.getMonth(), today.getDate())
      const diffTime = todayStart - DateStart
      const diffInDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24))

      if (diffInDays === 0) {
        return t('today')
      } else if (diffInDays === 1) {
        return t('yesterday')
      } else if (diffInDays > 1 && diffInDays <= 30) {
        return t('daysAgo', diffInDays, { count: diffInDays })
      } else {
        const diffInMonths = Math.ceil(diffInDays / 30)
        return t('monthsAgo', diffInMonths, { count: diffInMonths })
      }
    }
  }
}
